module.exports = __webpack_public_path__ + "img/GreekTechHypastpistS_ua.22d46456.webp";